import React from 'react';
import MUIDataTable from 'mui-datatables';

// Material Resources
import { IconButton, Tooltip, Typography, TableCell } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

// GraphQl
import { useQuery, useMutation } from '@apollo/react-hooks';

// Components & Others
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import CustomOptions from '../../../CustomOptions';
import LoadingIndicator from '../../../LoadingIndicator';
import { LIST_MARITAL_STATUS, DELETE_MARITAL_STATUS } from '../queries';
import CustomColumnHeader from '../../../TableComponents/CustomColumnHeader';
import { edgeToList, getOptions } from '../../../../utils/commonFunctions';
import { textLabels } from '../../../../translations/components/MUIDataTable';

// Styles & Images
import useStyles from './styles';

function CustomToolbar() {
  const history = useHistory();
  const handleClick = () => {
    history.push('/administrador/estados-civiles/crear');
  };

  return (
    <Tooltip title="Nueva estado civil">
      <IconButton color="secondary" onClick={handleClick}>
        <AddIcon />
      </IconButton>
    </Tooltip>
  );
}

function MaritalStatusList() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  const [deleteMaritalStatus] = useMutation(
    DELETE_MARITAL_STATUS,
    getOptions({
      mutationName: 'deleteMaritalStatus',
      modelName: 'maritalStatus',
      message: 'Estado civil eliminado con éxito.',
      enqueueSnackbar,
    })
  );
  const { loading, error, data } = useQuery(LIST_MARITAL_STATUS);
  if (error) {
    console.error(error);
  }

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
      options: {
        sort: true,
        customHeadRender: (columnMeta, updateDirection) => {
          return (
            <CustomColumnHeader
              id={0}
              key={0}
              columnMeta={columnMeta}
              updateDirection={updateDirection}
            />
          );
        },
      },
    },
    {
      name: 'spouse',
      label: 'Permite cónyuge',
      options: {
        sort: true,
        customHeadRender: (columnMeta, updateDirection) => {
          return (
            <CustomColumnHeader
              id={1}
              key={1}
              columnMeta={columnMeta}
              updateDirection={updateDirection}
            />
          );
        },
        customBodyRender: value => {
          const spouse = value;
          return <p>{spouse ? 'Si' : 'No'} </p>;
        },
      },
    },
  ];
  columns.push({
    name: 'id',
    label: 'Opciones',
    options: {
      sort: false,
      customBodyRender: value => {
        const id = value;
        return (
          <CustomOptions
            id={id}
            model="Estado civil"
            options={['oedit', 'odelete']}
            handleDelete={() => {
              deleteMaritalStatus({ variables: { id } });
              data.listMaritalStatus.edges = data.listMaritalStatus.edges.filter(
                e => e.node.id !== id
              );
            }}
          />
        );
      },
      customHeadRender: columnMeta => {
        return (
          <TableCell key={2} style={{ borderBottom: 'none' }}>
            <Typography
              variant="subtitle1"
              align="left"
              className={classes.tableTitle}
            >
              {columnMeta.label}
            </Typography>
          </TableCell>
        );
      },
    },
  });

  const handleRowClick = (rowData, rowMeta) => {
    if (rowData[rowData.length - 1] && rowData[rowData.length - 1].props) {
      history.push(
        `/administrador/estados-civiles/${rowData[rowData.length - 1].props.id}`
      );
    }
  };

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    selectableRows: 'none',
    print: false,
    filter: false,
    download: false,
    textLabels,
    customToolbar: () => {
      return <CustomToolbar />;
    },
    onRowClick: rowData => {
      handleRowClick(rowData);
    },
  };
  return (
    <>
      {loading ? (
        <LoadingIndicator />
      ) : (
        <MUIDataTable
          title="Estados civiles"
          data={edgeToList(data, 'listMaritalStatus')}
          columns={columns}
          options={options}
        />
      )}
    </>
  );
}

export default MaritalStatusList;
